import VCollapse from './VCollapse.vue';

export { VCollapse };
export default VCollapse;
